import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Stepper, Step, StepLabel } from '@mui/material';
import {
  internetProviderInterlinkData,
  steps
} from '@modules/entertainment/utils/live-tv.utils.ts';
import useLiveTvStore from '@modules/entertainment/pages/live-tv/store/live-tv.store.ts';
import InternetProviderFormContent from '@modules/entertainment/pages/live-tv/compnents/iptv-providers-dialog-content/components/internet-provider-form-content/internet-provider-form-content.tsx';
import InternetProviderCardContent from '@modules/entertainment/pages/live-tv/compnents/iptv-providers-dialog-content/components/internet-provider-card-content/internet-provider-card-content.tsx';
import { TableState } from '@store/table-store/table.model.ts';
import { RoutePaths } from '@utils/route.utils.ts';

const IptvProvidersDialogContent: React.FC<{
  onClose: () => void;
  state: TableState;
}> = ({ onClose, state }) => {
  const { t } = useTranslation();
  const { importInternetProvider, isLoading } = useLiveTvStore();
  const [activeStep, setActiveStep] = useState(0);
  const [isFormValid, setIsFormValid] = useState(false);

  const handleCardClick = () => setActiveStep(1);
  const handleBack = () => {
    setActiveStep(0);
    setIsFormValid(false);
  };

  const handleFormSave = (data: { apiKey: string }) => {
    const body = {
      name: 'interlink',
      ...data
    };

    importInternetProvider({
      data: body,
      handleClose: onClose,
      state
    });
  };

  return (
    <div className="w-full p-4">
      <p className="max-w-[60%] ml-auto mr-auto text-center text-base font-medium text-[rgba(25,27,27,0.8)] opacity-50 max-lg-xl:max-w-[80%]">
        {t('entertainment_live_tv_import_iptv_channels_desc')}
      </p>

      <Stepper activeStep={activeStep} alternativeLabel className="mt-8">
        {steps.map((label, index) => (
          <Step
            key={label}
            completed={
              (index === 0 && activeStep > 0) || (index === 1 && isFormValid)
            }
          >
            <StepLabel>{t(label)}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <div className="mt-14">
        {activeStep === 0 && (
          <>
            <div className="flex justify-center items-center">
              <InternetProviderCardContent
                item={internetProviderInterlinkData}
                onClick={handleCardClick}
              />
            </div>

            <div className="mt-8 mx-auto max-w-[500px] p-4 bg-[rgba(0,122,255,0.1);] rounded-lg border-l-4 border-[rgb(0,122,255)]">
              <p className="text-[12px] font-medium text-[rgba(25, 27, 27, 0.8)] opacity-50">
                {t('entertainment_live_tv_provider_not_listed_message')}{' '}
              </p>

              <p className="flex justify-end items-end cursor-pointer">
                <a
                  href={`${RoutePaths.Core.ContactUs.absolutePath}?category=integrations&title=Request Iptv Provider Integration`}
                  className="text-[rgb(0,122,255)] text-[12px] font-medium underline underline-offset-3 hover:!opacity-70"
                >
                  {t('entertainment_live_tv_request_integration')}
                </a>
              </p>
            </div>
          </>
        )}

        {activeStep === 1 && (
          <div className="h-[368px]">
            <InternetProviderFormContent
              onSave={handleFormSave}
              onBack={handleBack}
              item={internetProviderInterlinkData}
              onFormValidChange={setIsFormValid}
              isLoading={isLoading()}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default IptvProvidersDialogContent;
